// STYLES AND BLOCKS
import "../styles/styles.css";
import "./common.js";

// LIBRARIES
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

// ANIMATIONS

gsap.registerPlugin(ScrollTrigger);	
gsap.set(".reveal", { autoAlpha: 0, y: 20 });

ScrollTrigger.batch(".reveal", {
    start: "top 85%",
    once: true,
    onEnter: (els) =>
    gsap.to(els, { autoAlpha: 1, y: 0, duration: 0.8, ease: "power2.out", stagger: 0.1 }),
});

const menuTrigger = document.querySelector('#menu-trigger');
const navMobile = document.querySelector('#nav-main-mobile');
const navClose = navMobile.querySelector('.close');

const toggleMenu = (force) => {
    const isOpen = navMobile.classList.toggle('active', force);
    menuTrigger.classList.toggle('open', isOpen);
    menuTrigger.setAttribute('aria-expanded', isOpen);
};

menuTrigger.addEventListener('click', () => toggleMenu());

if (navClose) {
    navClose.addEventListener('click', () => toggleMenu(false));
}



